import { render, staticRenderFns } from "./PollPost.vue?vue&type=template&id=642a5e8c&scoped=true&"
import script from "./PollPost.vue?vue&type=script&lang=js&"
export * from "./PollPost.vue?vue&type=script&lang=js&"
import style0 from "./PollPost.vue?vue&type=style&index=0&id=642a5e8c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "642a5e8c",
  null
  
)

export default component.exports